import { Schema as S } from "effect";

// Calendar reference within a schedule type
const CalendarRefSchema = S.Struct({
  _id: S.String,
  calendarId: S.String,
});

// Required resource for a schedule type
const RequiredResourceSchema = S.Struct({
  _id: S.String,
  resourceType: S.optional(S.String),
});

const ScheduleTypeListItemSchema = S.Struct({
  _id: S.optional(S.String),
  name: S.String,
  duration: S.Number,
  durationUnit: S.Union(
    [S.Literal("MINUTES"),
    S.Literal("HOURS"),
    S.Literal("DAYS"),
    S.Literal("WEEKS")]
  ),
  // Calendar associations - this is how we know which calendars to query
  calendarRefs: S.optional(S.Array(CalendarRefSchema)),
  requiredResources: S.optional(S.Array(RequiredResourceSchema)),
  type: S.optional(
    S.Union(
      [S.Literal("STANDARD"),
      S.Literal("CONFERENCE"),
      S.Literal("ONLINE_CONSULTATION")]
    )
  ),
  isPublic: S.optional(S.Boolean),
  info: S.optional(S.String),
  isPreconfigured: S.optional(S.Boolean),
  noPatientMessage: S.optional(S.Boolean),
  capacity: S.optional(S.Number),
  numberOfSuggestedAppointments: S.optional(S.Number),
  color: S.optional(S.String),
  lastChanged: S.optional(S.String),
  designation: S.optional(S.String),
  details: S.optional(S.String),
  severity: S.optional(
    S.Union(
      [S.Literal("NONE"),
      S.Literal("LOW"),
      S.Literal("NORMAL"),
      S.Literal("IMPORTANT"),
      S.Literal("VERYIMPORTANT"),
      S.Literal("CRITICAL")]
    )
  ),
});

export const ListScheduleTypesResponseSchema = S.Array(
  ScheduleTypeListItemSchema
);

export type ListScheduleTypesResponse = S.Schema.Type<
  typeof ListScheduleTypesResponseSchema
>;
